import { Title } from '@common/components/Title';
import { Account } from '@features/accounts/types';
import { Flex } from '@radix-ui/themes';
import { Trans, useTranslation } from 'react-i18next';
import { AccountCard } from '../components/AccountCard';

interface AccountSelectionProps {
    accounts: Account[];
    onSelectAccount: (account: Account) => void;
}

export const AccountSelectionUI = ({
    accounts,
    onSelectAccount,
}: AccountSelectionProps) => {
    useTranslation();
    return (
        <Flex direction={'column'} gap={'2'} align={'center'}>
            <Title align={'center'} size={'7'}>
                <Trans i18nKey={'accountSelection:title'} />
            </Title>

            {accounts.map((account) => (
                <AccountCard
                    key={account.id}
                    account={account}
                    onSelected={onSelectAccount}
                />
            ))}
        </Flex>
    );
};
